/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_S3Inputs */

const en_lg_search_s3 = /** @type {(inputs: Lg_Search_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a result to open the exact message or thread reply. Use the next results or return to the first page to continue searching.`)
};

const id_lg_search_s3 = /** @type {(inputs: Lg_Search_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih hasil untuk membuka pesan atau balasan thread yang tepat. Gunakan hasil berikutnya atau kembali ke halaman pertama untuk melanjutkan pencarian.`)
};

/**
* | output |
* | --- |
* | "Select a result to open the exact message or thread reply. Use the next results or return to the first page to continue searching." |
*
* @param {Lg_Search_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_s3 = /** @type {((inputs?: Lg_Search_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_s3(inputs)
	return en_lg_search_s3(inputs)
});